/**
 * @generated SignedSource<<f08cf80f8e94b6820f224feb42cd7247>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type usersField_updateWorkItemFieldsActionRenderer$data = {
  readonly fieldId?: string;
  readonly name?: string;
  readonly selectedUsersConnection?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly accountId: string;
        readonly name: string;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "usersField_updateWorkItemFieldsActionRenderer";
};
export type usersField_updateWorkItemFieldsActionRenderer$key = {
  readonly " $data"?: usersField_updateWorkItemFieldsActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"usersField_updateWorkItemFieldsActionRenderer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
},
v1 = [
  {
    "kind": "ScalarField",
    "name": "fieldId"
  },
  (v0/*: any*/),
  {
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      }
    ],
    "concreteType": "JiraUserConnection",
    "kind": "LinkedField",
    "name": "selectedUsersConnection",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraUserEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "accountId"
              },
              (v0/*: any*/)
            ]
          }
        ]
      }
    ],
    "storageKey": "selectedUsersConnection(first:10)"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "usersField_updateWorkItemFieldsActionRenderer",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "JiraPeopleField"
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "JiraMultipleSelectUserPickerField"
    }
  ],
  "type": "JiraIssueField",
  "abstractKey": "__isJiraIssueField"
};
})();

(node as any).hash = "3b4bd59e8fb3446c8f7507895834aa0a";

export default node;
